import React, { useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { register, updateUser } from '../../../api/webServices';
import { setActualUser } from '../../../store/reducers/usersSlice';
import { getPermissions } from '../../../utils/various';

const User = () => {

    const { actualUser } = useSelector(state => state.users);
    const [user, setUser] = useState(actualUser || {});
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const vRef = useRef();
    const eRef = useRef();
    const dRef = useRef();
    const vcRef = useRef();
    const ecRef = useRef();
    const dcRef = useRef();

    //create form to edit and add an user with username, password, name, email, phone

    const handleChangeInput = (e) => {
        const { name, value } = e.target;
        setUser({ ...user, [name]: value });
    }

    const manageChecks = (role) => {
        if (role) {
            const permissions = getPermissions(role);
            vRef.current.checked = permissions.requests.view;
            eRef.current.checked = permissions.requests.edit;
            dRef.current.checked = permissions.requests.delete;
            vcRef.current.checked = permissions.contracts.view;
            ecRef.current.checked = permissions.contracts.edit;
            dcRef.current.checked = permissions.contracts.delete;
        } else {
            vRef.current.checked = true;
            eRef.current.checked = true;
            dRef.current.checked = false;
            vcRef.current.checked = true;
            ecRef.current.checked = true;
            dcRef.current.checked = false;
        }
    }

    const getPermissionsFromChecks = () => {
        let permissions = '';
        if (actualUser && actualUser.role.includes('a')) permissions += 'a';
        if (vRef.current.checked) permissions += 'v';
        if (eRef.current.checked) permissions += 'e';
        if (dRef.current.checked) permissions += 'd';
        if (vcRef.current.checked) permissions += 'V';
        if (ecRef.current.checked) permissions += 'E';
        if (dcRef.current.checked) permissions += 'D';
        return permissions;
    }

    useEffect(() => {
        manageChecks(actualUser?.role);
        return () => {
            dispatch(setActualUser(null));
        }
    }, []);

    const handleSubmit = (e) => {
        e.preventDefault();
        let userToSend = { ...user, role: getPermissionsFromChecks() };
        if (actualUser) {
            updateUser(userToSend).then(res => {
                navigate('/users')
            }).catch(err => {
                console.log(err);
            })
        } else {
            register(userToSend).then(res => {
                navigate('/users')
            }).catch(err => {
                console.log(err);
            })
            //add user
        }
        //send data to backend
    }

    return (
        <div className="flex flex-col items-center justify-center w-full h-full gap-20">
            <div className="w-[85%] bg-white h-[90%] my-auto rounded-2xl flex items-center justify-center">
                <form onSubmit={handleSubmit} className="flex flex-col w-[400px] border border-blue-500 p-5 rounded-xl">
                    <label className="pt-3" htmlFor="username">Usuario</label>
                    <input required disabled={actualUser} className="w-full px-3 py-2 leading-tight text-gray-900 border rounded shadow appearance-none focus:outline-none focus:shadow-outline" onChange={handleChangeInput} value={user?.username} type="text" name="username" id="username" />
                    <label className="pt-3" htmlFor="password">Contraseña</label>
                    <input required className="w-full px-3 py-2 leading-tight text-gray-900 border rounded shadow appearance-none focus:outline-none focus:shadow-outline" onChange={handleChangeInput} value={user?.password} type="password" name="password" id="password" />
                    <label className="pt-3" htmlFor="name">Nombre</label>
                    <input className="w-full px-3 py-2 leading-tight text-gray-900 border rounded shadow appearance-none focus:outline-none focus:shadow-outline" onChange={handleChangeInput} value={user?.name} type="text" name="name" id="name" />
                    <label className="pt-3" htmlFor="email">Email</label>
                    <input className="w-full px-3 py-2 leading-tight text-gray-900 border rounded shadow appearance-none focus:outline-none focus:shadow-outline" onChange={handleChangeInput} value={user?.mail || ''} type="email" name="mail" id="mail" />
                    <label className="pt-3" htmlFor="phone">Teléfono</label>
                    <input className="w-full px-3 py-2 leading-tight text-gray-900 border rounded shadow appearance-none focus:outline-none focus:shadow-outline" onChange={handleChangeInput} value={user?.phone} type="text" name="phone" id="phone" />
                    <div className="flex flex-col w-full gap-3 mt-4">
                        <p className="w-full">Permisos solicitudes</p>
                        <div className="flex justify-between w-full">
                            <div className="flex gap-2">
                                <input ref={vRef} type="checkbox" name="s_visualizar" id="s_visualizar" />
                                <label htmlFor="s_visualizar">Visualizar</label>
                            </div>
                            <div className="flex gap-2">
                                <input ref={eRef} type="checkbox" name="s_editar" id="s_editar" />
                                <label htmlFor="s_editar">Editar</label>
                            </div>
                            <div className="flex gap-2">
                                <input ref={dRef} type="checkbox" name="s_eliminar" id="s_eliminar" />
                                <label htmlFor="s_eliminar">Eliminar</label>
                            </div>
                        </div>
                    </div>
                    <div className="flex flex-col w-full gap-3 mt-4">
                        <p className="w-full">Permisos contratos</p>
                        <div className="flex justify-between w-full">
                            <div className="flex gap-2">
                                <input ref={vcRef} type="checkbox" name="c_visualizar" id="c_visualizar" />
                                <label htmlFor="c_visualizar">Visualizar</label>
                            </div>
                            <div className="flex gap-2">
                                <input ref={ecRef} type="checkbox" name="c_editar" id="c_editar" />
                                <label htmlFor="c_editar">Editar</label>
                            </div>
                            <div className="flex gap-2">
                                <input ref={dcRef} type="checkbox" name="c_eliminar" id="c_eliminar" />
                                <label htmlFor="c_eliminar">Eliminar</label>
                            </div>
                        </div>
                    </div>
                    <button className="w-full px-3 py-2 mt-4 text-white bg-blue-500 rounded shadow hover:bg-blue-400 focus:outline-none focus:shadow-outline">Aceptar</button>
                </form>
            </div>
        </div>
    )
}

export default User